var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglass = function SvgIconHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.75 2A1.75 1.75 0 0 0 5 3.75v3.381a1.76 1.76 0 0 0 .695 1.39l.005.004L10.333 12 5.7 15.475l-.005.004A1.76 1.76 0 0 0 5 16.869v3.381A1.75 1.75 0 0 0 6.75 22h10.5A1.75 1.75 0 0 0 19 20.25v-3.344a1.76 1.76 0 0 0-.695-1.39L13.657 12l4.646-3.515.002-.001A1.76 1.76 0 0 0 19 7.094V3.75A1.75 1.75 0 0 0 17.25 2zM7 7V4h10v2.963l-5.003 3.785zm4.997 6.252L7 17v3h10v-2.963z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglass;